var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon order black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-order-black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 50 0 50 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0555556,8 L9.94444444,8 L9.94444444,12.375 L41.0555556,12.375 L41.0555556,8 Z M43,29.875 L43,25.5 L41.0555556,14.5625 L9.94444444,14.5625 L8,25.5 L8,29.875 L9.94444444,29.875 L9.94444444,43 L29.3888889,43 L29.3888889,29.875 L37.1666667,29.875 L37.1666667,43 L41.0555556,43 L41.0555556,29.875 L43,29.875 Z M25.5,38.625 L13.8333333,38.625 L13.8333333,29.875 L25.5,29.875 L25.5,38.625 Z",
    id: "Shape",
    fill: "#505050",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGrey);
export default __webpack_public_path__ + "static/media/home-grey.ea4a5bc839fbcf7c6aeb04e7e9a3a22d.svg";
export { ForwardRef as ReactComponent };